import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText, Lock, Copy, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const [active, setActive] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => { api.get("/documents").then(r => setDocs(r.data.documents)); }, []);

  const open = async (d) => {
    if (d.locked) return;
    const { data } = await api.get(`/documents/${d.slug}`);
    setActive(data.document);
  };
  const copyContent = () => {
    if (!active?.content) return;
    navigator.clipboard.writeText(active.content);
    setCopied(true); setTimeout(()=>setCopied(false), 1500);
    toast.success("Copied to clipboard");
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="documents-page">
      <div className="lg:col-span-1">
        <h1 className="text-2xl font-extrabold tracking-tight">Documents & Templates</h1>
        <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">Copy-ready HSE templates.</p>
        <div className="mt-4 space-y-2">
          {docs.map(d => (
            <button key={d.doc_id} data-testid={`doc-${d.slug}`} onClick={()=>open(d)}
                    className={`w-full text-left rounded-xl border p-3 flex items-center justify-between ${active?.slug === d.slug ? "border-amber-500 bg-amber-500/5" : "border-slate-200 dark:border-slate-800 hover:border-slate-300"}`}>
              <div className="flex items-center gap-2"><FileText className="h-4 w-4 text-slate-500" /><span className="text-sm font-medium">{d.title}</span></div>
              {d.locked && <Lock className="h-3 w-3 text-amber-500" />}
            </button>
          ))}
        </div>
      </div>
      <div className="lg:col-span-2">
        {active ? (
          <div className="rounded-2xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-5">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-bold">{active.title}</h2>
              <button data-testid="doc-copy" onClick={copyContent} className="btn-outline !py-1.5 !px-3 text-xs">{copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />} Copy</button>
            </div>
            <pre className="whitespace-pre-wrap font-mono text-sm bg-slate-50 dark:bg-slate-950/50 p-4 rounded-xl border border-slate-200 dark:border-slate-800 overflow-x-auto">{active.content}</pre>
          </div>
        ) : (
          <div className="rounded-2xl border border-dashed border-slate-300 dark:border-slate-700 p-10 text-center text-slate-500">
            Select a template to preview.
            <div className="mt-3"><Link to="/subscription" className="text-amber-600 font-semibold">Unlock all premium templates →</Link></div>
          </div>
        )}
      </div>
    </div>
  );
}
